import React from "react";
import "../index.scss";
import {Button} from "../../../atoms";
import { AI_CHAT_INACTIVITY_MESSAGE, AI_CHAT_INACTIVITY_MESSAGE_CLOSE_BUTTON, AI_CHAT_INACTIVITY_MESSAGE_NEW_BUTTON } from "utils/constants/GoogleTagGUIDs";

interface IProps {
    onNewChat: () => void;
    onClose: () => void;
}

const ChatIdleMessage: React.FC<IProps> = ({onNewChat, onClose}: IProps) => {
    return (
        <div className={`chat-message ai-message`}>
            <div className="message-content">
                <div className="message-bubble" data-tracking-id={AI_CHAT_INACTIVITY_MESSAGE}>
                    It looks like you’ve been away for a while.  Your session has ended.  Would you like to start a new session or close this session?
                    <br/>
                    <div className="idle-button-container">
                        <Button
                            label="New"
                            icon={false}
                            type="filter"
                            styles="ai-review-btn ai-review-btn-filter"
                            onClick={onNewChat}
                            dataTrackingId={AI_CHAT_INACTIVITY_MESSAGE_NEW_BUTTON}
                        />
                        <Button
                            label="Close"
                            icon={false}
                            type="score"
                            styles="ai-review-btn "
                            onClick={onClose}
                            dataTrackingId={AI_CHAT_INACTIVITY_MESSAGE_CLOSE_BUTTON}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatIdleMessage;
